'use strict';

customerZone

.component('roamingWizard', {
    bindings: {},
    templateUrl: customerZone.fromBase('components/roaming-wizard/roaming-wizard.component.html'),
    controller: ['roamingAndInternationalTariffsProvider', '$log', 'utils', 'ProductService', 'Session', '$q', 'config',
        function(tariffsProvider, $log, utils, ProductService, Session, $q, config){

            var vm = this;
            var HOME = 'home';
            var homeCountry = 'be';
            var countries = {};
            var tariffs = {};

            vm.roaming = false;
            vm.loading = true;
            vm.validSelection = true;

            vm.imagesPath = config['isoFlagsCdn'];

            vm.isoCountries = {};

            vm.fromCountry = homeCountry;
            vm.toCountry = homeCountry;
            vm.selectedProduct = Session.subscriber() && Session.subscriber().product.id
                ? Session.subscriber().product.id
                : '2350982-1-1';

            var userProducts = Session.subscribers().map(function(subscription) {
                var product = {};
                Object.assign(product, subscription.product);
                product.msisdn = subscription.msisdn;
                return product;
            });

            var init = function(){
                /**
                 * Retrieve all the active prepaid and postpaid products
                 * @return (a promise to) an array of products
                 */
                var getStandardProducts = ProductService.getAllProducts()
                    .then(function (products) {
                        var selectableProducts = products.filter(function(product){
                            return (product.type === 'prepaid') || (product.type === 'postpaid');
                        });
                        vm.selectOptions = userProducts.concat(selectableProducts);
                    });

                var tariffsPromise = tariffsProvider.getData()
                    .then(function(data){
                        countries = data['countries'];
                        Object.keys(countries).forEach(function(item){
                            vm.isoCountries[item] = utils.translate('country_' + item);
                        });
                        tariffs = data['tariffs'];
                    });


                $q.all([getStandardProducts, tariffsPromise])
                    .then(function(){
                        vm.applySelection();
                        vm.loading = false;
                    })
                    .catch(function(error){
                        $log.error('Couldn\'t properly initialize the roaming wizard component', error);
                        utils.showError();
                    });
            };

            init();

            vm.isSelectionDone = function(){
                return Object.keys(vm.isoCountries).includes(vm.fromCountry)
                    && Object.keys(vm.isoCountries).includes(vm.toCountry);
            };

            vm.applySelection = function(){
                if (!vm.isSelectionDone()) {
                    vm.validSelection = false;
                    return;
                }
                vm.validSelection = true;
                var fromZone = vm.fromCountry === homeCountry
                    ? homeCountry
                    : countries[vm.fromCountry].zone;
                var toZone = (vm.fromCountry === homeCountry && vm.toCountry === homeCountry)
                    ? homeCountry
                    : countries[vm.toCountry].zone;
                var fromZoneTariffs = tariffs[fromZone];
                var homeTariffs = tariffs['Home'][vm.selectedProduct];

                vm.roaming = vm.fromCountry !== homeCountry;

                vm.callOut = tariff(fromZoneTariffs.out, 'call', toZone);
                vm.callIn = tariff(fromZoneTariffs.in, 'call');
                vm.smsOut = tariff(fromZoneTariffs.out, 'sms', toZone);
                vm.smsIn = tariff(fromZoneTariffs.in, 'sms');
                vm.dataFee = tariff(fromZoneTariffs.in, 'data');

                function tariff(prices, type, toZone){
                    var selected = prices[type];
                    if (toZone) selected = selected[toZone];
                    if (selected === HOME) selected = homeTariffs[type];
                    return formatTariff(selected, type);
                }

                function formatTariff (value, type){
                    if (value === 0) return utils.translate('free');
                    if (value === 'n/a' && type === 'data') return utils.translate('no_data_roaming_outside_of_eu');
                    var mapping = {
                        call: ' €/min.',
                        sms: ' €/SMS',
                        data: ' €/MB'
                    };
                    return value + mapping[type];
                }
            };

            /**
             * Will be passed to the auto complete component
             * @param inputValue This represents the user's input
             * @return {Function} This is the function used to narrow the list depending on the user's input
             */
            vm.startsWith = function(inputValue){
                return function(candidate){
                    return candidate[1].toLowerCase().startsWith(inputValue.toLowerCase());
                };
            };
        }],
    controllerAs: 'vm'
});
